import { ReactNode } from 'react';

import { Objects } from '../translations/Objects';

type ObjectsWithDefault = { DEFAULT: ReactNode; PLURAL?: ReactNode };

/**
 * Maps an entity ID field key (e.g. `iot_id`, `user_ids`, `workflow_step_id`)
 * to its corresponding translation from CommonMessage.OBJECTS.
 *
 * - Singular keys ending in `_id` → `.DEFAULT`
 * - Plural keys ending in `_ids` → `.PLURAL`
 *
 * Returns `undefined` if no matching OBJECTS entry is found.
 */
export const getEntityIdTranslation = (fieldKey: string): ReactNode | undefined => {
    const isPlural = fieldKey.endsWith('_ids');
    const entityKey = (isPlural ? fieldKey.slice(0, -4) : fieldKey.slice(0, -3)).toUpperCase();
    const entry = Objects[entityKey as keyof typeof Objects] as ObjectsWithDefault | undefined;

    if (entry == null || typeof entry !== 'object') return undefined;

    if (isPlural && 'PLURAL' in entry) return entry.PLURAL;
    if ('DEFAULT' in entry) return entry.DEFAULT;

    return undefined;
};
